import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CalendarEvent } from 'angular-calendar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatColors } from '../../../../../core/matColors';
import { Transaction } from '../../../../../core/services/transactions/transactions.model';
import { TRANS_TYPE } from '../../../../../core/services/transactions/transaction.constants';

@Component({
    selector     : 'fuse-transac-form-dialog',
    templateUrl  : './transac-form.component.html',
    styleUrls    : ['./transac-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TransacFormDialogComponent implements OnInit
{
    transac: Transaction;
    dialogTitle: string;
    eventForm: FormGroup;
    action: string;
    dueAmount: number;
    presetColors = MatColors.presets;

    types = [
        TRANS_TYPE.ESPECE,
        TRANS_TYPE.TPE,
        TRANS_TYPE.CHEQUE,
        TRANS_TYPE.VIREMENT,
        TRANS_TYPE.CHEQUE_VACANCE,
        TRANS_TYPE.BON_CADEAU,
    ]

    constructor(
        public dialogRef: MatDialogRef<TransacFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private formBuilder: FormBuilder
    )
    {
        this.transac = data.transac;
        this.action = data.action;
        this.dueAmount = data.dueAmount;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = this.transac.type;
        }
        else
        {
            this.dialogTitle = 'Ajout transaction';
            this.transac = new Transaction();
        }

        this.eventForm = this.createEventForm();
    }

    ngOnInit()
    {
    }

    createEventForm()
    {
        return new FormGroup({
            // _id             : new FormControl(this.transac._id),
            type           : new FormControl(this.transac.type, [Validators.required]),
            // description     : new FormControl(this.transac.description),
            vads_amount          : new FormControl(this.transac.vads_amount || this.dueAmount, [Validators.required, Validators.min(0), Validators.max(this.dueAmount)]),
            // discountAmount  : new FormControl(this.transac.discountAmount, [Validators.required, Validators.min(0)]),
            // vatRate         : new FormControl(this.transac.vatRate, [Validators.required, Validators.min(0)]),
            // allDay: new FormControl(this.event.allDay),
            // color : this.formBuilder.group({
            //     primary  : new FormControl(this.event.color.primary),
            //     secondary: new FormControl(this.event.color.secondary)
            // }),
            // meta  :
            //     this.formBuilder.group({
            //         location: new FormControl(this.event.meta.location),
            //         notes   : new FormControl(this.event.meta.notes)
            //     })
        });
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/order/transac-form/transac-form.component.ts